export default __webpack_public_path__ + "static/mch_256_a-a8024e64f992514a630cb9c377949ba8.png";